import { isWeb, isWebView } from 'src/utils/platform';
const SEO_CRAWLER_UA = /googlebot|google-inspectiontool|bingbot|slurp|duckduckbot|baiduspider|yandexbot|facebookexternalhit|twitterbot|linkedinbot|applebot|discordbot|whatsapp|telegrambot/i;
function detectSeoCrawler() {
    if (!isWeb || isWebView || typeof navigator === 'undefined') {
        return false;
    }
    if (SEO_CRAWLER_UA.test(navigator.userAgent)) {
        return true;
    }
    if (typeof window !== 'undefined') {
        try {
            const params = new URLSearchParams(window.location.search);
            return params.get('seo_crawler') === '1';
        }
        catch {
            return false;
        }
    }
    return false;
}
/**
 * True when the app is opened by a search/social crawler (or dev `?seo_crawler=1`).
 * Always false inside the native WebView and on native shells.
 */
export const isSeoCrawler = detectSeoCrawler();
